
// @flow
import failedLeagueVendorUpdateBlock from './failedLeagueVendorUpdateBlock'

export default failedLeagueVendorUpdateBlock

